// mediaPlayGuard.js - no error reports when a video or sound is paused while it is starting.
//
// audio.play() / video.play() return a promise. When the editor pauses, seeks or removes the
// element before playback has started (the preview and the timeline do this all the time), the
// browser rejects that promise ("The play() request was interrupted by a call to pause()").
// About 40 places in the editor call play() without handling the result, so each of those became
// an "Uncaught (in promise)" error (in development a full-screen error overlay on every preview).
//
// This marks those expected interruptions as handled. Code that does handle the promise still
// gets the rejection as before; any other failure (e.g. a missing file) is still logged.

const EXPECTED = new Set(["AbortError", "NotAllowedError"]);

if (typeof window !== "undefined" && window.HTMLMediaElement && !window.HTMLMediaElement.prototype.__toonsPlayGuard) {
  const originalPlay = window.HTMLMediaElement.prototype.play;
  window.HTMLMediaElement.prototype.play = function play() {
    const result = originalPlay.apply(this, arguments);
    if (result && typeof result.catch === "function") {
      result.catch((error) => {
        if (!error || !EXPECTED.has(error.name)) console.warn("Media could not be played:", this.currentSrc || this.src, error);
      });
    }
    return result;
  };
  window.HTMLMediaElement.prototype.__toonsPlayGuard = true;
}
